'use strict';

var App = require('app');
var Consts = require('consts');
var Device = require('models/devices').Model;
var i18n = require('utils/i18n');
var Notification = require('utils/notification');

var RestartDeviceDialogView = Marionette.ItemView.extend({
    template: require('components/devices/templates/common/restart_device_dialog'),

    initialize: function (options) {
        this.options = options;

        this.controller = options.controller;
        this.device = options.device;
        this.phase = options.phase || 1;
        this.retries = 0;
        this.error = undefined;

        var self = this;
        setTimeout(function () {
            self.doPhase();
        }, 500);
    },

    serializeData: function () {
        return {
            phase: this.phase,
            error: this.error,
        };
    },

    doPhase: function () {
        var self = this;
        this.controller.restartDevicePhase({
            device: this.device,
            phase: this.phase,

            success_cb: function () {
                self.phase++;
                self.render();
                self.doPhase();
            },
            error_cb: function (error) {
                if (self.phase == 3) {
                    if (self.retries < 5) {
                        // retry
                        self.retries++;
                        self.doPhase();

                        return;
                    } else {
                        error = i18n.TR('Gerät noch nicht wieder verbunden.');
                    }
                } else {
                    self.error = error.error;
                }
                self.render();
            },
        });
    },
});

module.exports = RestartDeviceDialogView;
